<template>
	<div class="demoLeftCenter">
		
		<div class="cell" :class="{'activeimg': activeIndex == index}" v-for="(item, index) in centerInfo">
			<div class="name">{{item.station_name}}</div>
			<div class="shishi">
				<span class="nengli">实时调节能力:</span>
				<span class="nenglinum">{{target[index].time}}</span>
				<span class="nengli">kw</span>
			</div>
		</div>
		<div class="sutonglu">
			<div class="namesutonglu">苏州苏桐路站</div>
			<div class="shishi">
				<span class="nengli">实时调节能力:</span>
				<span class="nenglinum">{{target[5].time}}</span>
				<span class="nengli">kw</span>
			</div>
		</div>
		<div class="songbeilu">
			<div class="namesongbeilu">苏州工业园区淞北路站</div>
			<div class="shishi">
				<span class="nengli">实时调节能力:</span>
				<span class="nenglinum">{{target[6].time}}</span>
				<span class="nengli">kw</span>
			</div>
		</div>
		<div class="AI"></div>
		<div class="shuzinengyuanpingtai">算力数字能源平台</div>
		<div class="shexian">
			<img src="@/assets/images/exposition/suanli.png" alt="">
		</div>
	</div>
</template>

<script>
	import {
		dataInterface
	} from "@/api/dataInterfaceApi"
	export default{
		data() {
			return{
				// indexNumber : 0,
				target: [
				  {
				    time: "39",
				  },
				  {
				    
				    time: "47",
				    
				  },
				  {
				    time: "58",
				  
				  },
				 {
				   time: "89",
				 
				 }, {
				    time: "105",
				  
				  }, {
				    time: "34",
				  
				  }, {
				    time: "68",
				  
				  },
				],
				activeIndex: 0,
				centerInfo: [],
				centerInfo1: [{
					name: '苏州苏桐路站'
				},{
					name: '苏州工业园区淞北路站'
				},]
			}
		},
		methods:{
			generateRandomNumber(min, max) {
			  var randomNumber = Math.random() * (max - min) + min;
			  return Math.floor(randomNumber);
			},
			changeColor() {
				// let indexNumber = 0
				this.timer = setInterval(() => {
					this.activeIndex++
						localStorage.setItem("dummySattionId", this.centerInfo[this.activeIndex].station_id)
						localStorage.setItem("dummySattionName", this.centerInfo[this.activeIndex].station_name)
							this.$bus.$emit('updateDummyFn')
							this.$bus.$emit('updateTiaoJieXiaoLv')
							this.$bus.$emit('updateBianyaqi')
							this.$bus.$emit('updatetankuangEcharts1')
							this.$bus.$emit('updateTiaoJieFuHe')
							this.$bus.$emit('updateTankuang')
						
							
					if(this.activeIndex >= this.centerInfo.length -1) {
						this.activeIndex = 0;
						localStorage.setItem("dummySattionId", this.centerInfo[0].station_id)
						localStorage.setItem("dummySattionName", this.centerInfo[0].station_name)
						this.$bus.$emit('updateDummyFn');
					}
					
				},8000)
			},
			getData() {
				let params = {
					"@province": '320500',
					enCode: 'powerplant-left-hdzwz'
					
				}
				dataInterface
					.dataFaceApi(params)
					.then((res) => {
						if (!res) return;
						// console.log("苏州", res)
						res.forEach((item, index) => {
							// console.log(item,'itenm')
							if(item.station_id!='878dda75ea784acdb86c04080c77fd87'&&item.station_id!='b351e58234a642638e614d6f3097a7ea'){
								 this.centerInfo.push(item)
							}
						    // xData.push(item.cur_date)
						    // yData1.push((parseFloat(item.DayStationLod || 0) * 100).toFixed(0))
						    // yData2.push(item.pass_num)
						})
						// console.log(this.centerInfo,'this.centerInfo')
						// this.centerInfo = res
						
						localStorage.setItem("dummySattionId", this.centerInfo[0].station_id)
						localStorage.setItem("dummySattionName", this.centerInfo[0].station_name)
						this.$bus.$emit('updateDummyFn');
					})
					.catch((err) => {
						console.log(err);
					});
			}
		},
		mounted() {
			this.changeColor();
			this.getData();
			this.timer1 = setInterval(() =>{
			  this.target[0].time = this.generateRandomNumber(10,120)
			},15000);
			this.timer2 = setInterval(() =>{
			  this.target[1].time = this.generateRandomNumber(10,120)
			},15000);
			this.timer3 = setInterval(() =>{
			  this.target[2].time = this.generateRandomNumber(10,120)
			},15000)
			this.timer4 = setInterval(() =>{
			  this.target[3].time = this.generateRandomNumber(10,120)
			},15000);
			this.timer5 = setInterval(() =>{
			  this.target[4].time = this.generateRandomNumber(10,120)
			},15000)
			this.timer6 = setInterval(() =>{
			  this.target[5].time = this.generateRandomNumber(10,120)
			},15000)
			this.timer7 = setInterval(() =>{
			  this.target[6].time = this.generateRandomNumber(10,120)
			},15000)
		},
		destroyed() {
			clearInterval(this.timer)
			clearInterval(this.timer1)
			clearInterval(this.timer2)
			clearInterval(this.timer3)
			clearInterval(this.timer4)
			clearInterval(this.timer5)
			clearInterval(this.timer6)
			clearInterval(this.timer7)
		}
	}
</script>

<style lang="scss" scoped>
	@font-face {
	  font-family: "Alibaba-PuHuiTi-Heavy";
	  src: url("~@/assets/font/Alibaba-PuHuiTi-Heavy.ttf");
	}
	@font-face {
	  font-family: "HT";
	  src: url("~@/assets/font/HT.ttf");
	}
	.demoLeftCenter{
		// opacity: 0.2;
		width: 100%;
		height: 1700px;
		position:relative;
		.cell{
			width: 367px;
			height: 170px;
			position: absolute;
			background-image: url("~@/assets/images/exposition/bg-green.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 1000;
			// display: flex;
			.name{
				letter-spacing:3px;
				font-weight: bold;
				text-align: center;
				// padding-left: 110px;
				// height: 80px;
				line-height:67px;
				font-size: 32px;
			}
			.shishi{
				text-align: center;
				line-height: 10px;
				display: flex;
				margin-left: 57px;
			}
			.nengli{
				font-size: 24px;
			}
			.nenglinum{
				display: block;
				margin-left: 10px;
				margin-right: 10px;
				font-size: 36px;
				color: #14F3F8;
				 font-family: "HT";
			}
		}
		.sutonglu{
			width: 346px;
			height: 170px;
			position: absolute;
			background-image: url("~@/assets/images/exposition/bg-green.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 1000;
			left: 628px;
			top:622px;
			.namesutonglu{
				letter-spacing:3px;
				font-weight: bold;
				text-align: center;
					line-height:67px;
				// padding-left: 110px;
				// height: 80px;
				// line-height: 110px;
				font-size: 32px;
			}
			.shishi{
				text-align: center;
				line-height: 10px;
				display: flex;
				margin-left: 57px;
			}
			.nengli{
				font-size: 24px;
			}
			.nenglinum{
				display: block;
				margin-left: 10px;
				margin-right: 10px;
				font-size: 36px;
				color: #14F3F8;
				 font-family: "HT";
			}
		}
		.songbeilu{
			width: 400px;
			height: 170px;
			position: absolute;
			background-image: url("~@/assets/images/exposition/bg-green.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 1000;
			left: 961px;
			top:711px;
			.namesongbeilu{
					line-height:67px;
				font-weight: bold;
				text-align: center;
				// padding-left: 110px;
				// height: 80px;
				// line-height: 110px;
				font-size: 32px;
			}
			.shishi{
				text-align: center;
				line-height: 10px;
				display: flex;
				margin-left: 79px;
			}
			.nengli{
				font-size: 24px;
			}
			.nenglinum{
				display: block;
				margin-left: 10px;
				margin-right: 10px;
				font-size: 36px;
				color: #14F3F8;
				 font-family: "HT";
			}
		}
	
		.activeimg{
			background-image: url("~@/assets/images/exposition/bg-yellow.png");
			// color: #0EFDC6;
		}
		.cell:nth-child(1) {
			left:691px;
			top:955px;
		}
		.cell:nth-child(2) {
			left:1818px;
			top:129px;
		}
		.cell:nth-child(3) {
			left: 322px;
			top:905px;
		}
		.cell:nth-child(4) {
				left:548px;
				top:371px;
		}
		
		.cell:nth-child(5) {
			left:1525px;
			top:465px;
		}
		
		// .cell:nth-child(5) {
		// 	left:528px;
		// 	top:400px;
		// }
		
		.AI{
			width: 484px;
			height: 196px;
			position: absolute;
			left: 967px;
			top: 527px;
			background-image: url("~@/assets/images/exposition/AI.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			z-index: 1000;
		}
		.shuzinengyuanpingtai{
			font-weight: bold;
			font-size: 48px;
			line-height: 133px;
			text-align: center;
			position: absolute;
			left: 1041px;
			top: 376px;
			width: 426px;
			height: 133px;
			background-image: url("~@/assets/images/exposition/shuzinengyuanpingtai.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			
		}
		.shexian{
			width: 484px;
			height: 196px;
			// width: 100%;
			// height: 170px;
			position: absolute;
			top: -90px;
			left: 988px;
			z-index: 1000;
			// background-color: pink;
			img{
				display: block;
				// width: 493px;
				height: 596px;
			}
		}
		
	}
</style>